import { useState } from "react";
import { Box, Button, Paper, alpha } from "@mui/material";
import { styled } from "@mui/material/styles";
import Navbar from "../../components/navbar";
import StrongDomainsPage from "../../components/Counselling/DomainInfo/StrongDomainsPage";

// ✅ Your existing styled components (unchanged)
const DashboardWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
  minHeight: "100vh",
  backgroundColor: "#f8fafc",
  overflow: "hidden",
  "&::before": {
    content: '""',
    position: "absolute",
    width: "100%",
    height: "100%",
    left: 0,
    top: 0,
    backgroundImage: `url('/image 7.png')`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% 100%",
    backgroundPosition: "center",
    backgroundColor: "#f8fafc",
    opacity: 1,
    zIndex: 0,
    pointerEvents: "none",
  },
}));

const ContentContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  maxWidth: "1200px",
  margin: "0 auto",
  padding: theme.spacing(3),
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2),
  },
  zIndex: 1,
}));

// --------------------
// ✅ MAIN COMPONENT
// --------------------
const DomainInfo = () => {
  //   const [step, setStep] = useState(1);

  //   const handleNext = () => setStep((prev) => prev + 1);
  //   const handleBack = () => setStep((prev) => prev - 1);

  //   const renderStep = () => {
  //     switch (step) {
  //       case 1:
  //         return <StepOne onNext={handleNext} />;
  //       case 2:
  //         return <StepTwo onNext={handleNext} onBack={handleBack} />;
  //       case 3:
  //         return <StepThree onNext={handleNext} onBack={handleBack} />;
  //       case 4:
  //         return <StepFour onBack={handleBack} />;
  //       default:
  //         return null;
  //     }
  //   };

  return (
    <DashboardWrapper>
      <Navbar />
      <ContentContainer>
        <StrongDomainsPage />
      </ContentContainer>
    </DashboardWrapper>
  );
};

export default DomainInfo;
